<template>
  <div id="swipe-cta">
    <canvas ref="swipeprogress" class="swipe-progress"></canvas>
  </div>
</template>

<script>
 
import Raf from '@/helpers/Raf'
import store from '@/store'
import { mapState, mapMutations } from 'vuex' 
import {map, clamp} from 'src/helpers/MathUtils'

import Arrow from 'src/components/swipecta/arrow'
import Pill from 'src/components/swipecta/pill'
import Dots from 'src/components/swipecta/dots'
import TweenLite from 'gsap'
import ResizeService from 'src/services/ResizeService' 

export default {

  name: 'swipe-cta',

  data() {
    return {
      tweenObj: {
        progress: 0 
      },
      initialised: false
    }
  },

  props: ['bottom_position'],

  computed: {
    ...mapState('app', ['app_state', 'consented']),
    ...mapState('swipeup', ['progress', 'input_state' ])
  },

  mounted() {
 
    this.c = this.$refs.swipeprogress;
    this.ctx = this.c.getContext("2d");
 
    this.pixelRatio = clamp(window.devicePixelRatio, 1, 2);
    this.BASE_HEIGHT = 180;

    // size container 
    this.w = 55;
    this.h = this.BASE_HEIGHT;

   // this.$el.style.height = (this.h * 0.1) + 'rem'; // this.h  + 'px';
    this.$el.style.width = this.w + 'px';
    this.$el.style.height = this.h + 'px';

    // size canvas
    this.c.width = this.w * this.pixelRatio;
    this.c.height = this.h * this.pixelRatio;
    this.c.style.width = this.w + 'px';
    this.c.style.height = this.h + 'px';

    // !! don't factor in pixelRatio here
    this.lineWidth = 1.5;
    this.padding = 2; 
    this.d = this.w - (this.padding * 2); // diameter 
    this.r = (this.d * 0.5); // radius  
    this.NUM_OF_DOTS = 8 ; //Math.round((this.h - this.d) / this.r);
    this.bottom = ((this.h - this.r) - this.padding);
    this.top = (this.h - this.r) - this.padding; 
    this.left = ((this.w * 0.5) - this.r); 
    this.right = ((this.w * 0.5) + this.r); 
    this.center = (this.w * 0.5); 
    this.y = { 
      start: this.bottom * this.pixelRatio, // lerped
      end: 1 // tweened on swipe complete
    };

    this.resize();
  
    // factor in pixelRatio here
    this.points = {

      // arc
      top: { 
        x: this.center * this.pixelRatio, 
        y: this.top * this.pixelRatio
      },

      // line
      right: {
        top: {
          x: this.right * this.pixelRatio,
          y: this.top * this.pixelRatio
        }, 
        bottom: {
          x: this.right * this.pixelRatio,
          y: this.bottom * this.pixelRatio
        }
      },

      // arc
      bottom: { 
        x: this.center * this.pixelRatio,
        y: this.bottom  * this.pixelRatio
      },

      // line
      left: {
        top: {
          x: this.left * this.pixelRatio,
          y: this.top * this.pixelRatio
        }, 
        bottom: {
          x: this.left * this.pixelRatio,
          y: this.bottom * this.pixelRatio
        }
      }

    };


    this.continue();

  },

  beforeDestroy() { },

  methods: {

    ...mapMutations('swipeup', [
      'setProgress' 
    ]), 
    
    resize() { 
      //this.h = this.$el.offsetHeight; 
    },

    setupViews(){
      let config = {
        ctx: this.ctx,
        lineWidth: this.lineWidth,
        pixelRatio: this.pixelRatio,
        radius: this.r,
        points: this.points,
        padding: this.padding,
        progress: this.progress,
        NUM_OF_DOTS: this.NUM_OF_DOTS,
        height: this.h
      };
 
      this.arrow = new Arrow(config);
      this.pill = new Pill(config);
      this.dots = new Dots(config); 
    },

    addEvents(){
      ResizeService.on(ResizeService.Events.RESIZE, this.resize); 
      Raf.add(this.draw); 
    },

    removeEvents(){
      ResizeService.off(ResizeService.Events.RESIZE, this.resize); 
      Raf.remove(this.draw); 
    },

    updatePositions(){
      let bottom = this.r + this.padding + (this.BASE_HEIGHT - this.h);
      let tgy = map(this.progress, 1, 0, bottom , this.top) * this.pixelRatio;
      this.y.start += (tgy - this.y.start) * 0.2;
      this.points.top.y = this.y.start;
      this.points.right.top.y = this.y.start;
      this.points.left.top.y = this.y.start;
    },

    draw(){
      this.ctx.clearRect(0, 0, this.c.width, this.c.height); 
      this.updatePositions();

      this.pill.draw(this.progress);
      this.dots.draw(this.progress);
      this.arrow.draw(this.progress); 
      //this.loadingCircle.draw(this.progress); 
    },

    drawLoadingCircle(){
      this.ctx.save(); 
      this.ctx.beginPath();
      this.ctx.strokeStyle = "#FFF"; 
      this.ctx.lineWidth = this.lineWidth * this.pixelRatio;
      this.ctx.arc(this.points.bottom.x, (this.points.bottom.y - this.padding), this.r * this.pixelRatio ,0,2*Math.PI); 
      this.ctx.stroke(); 
      this.ctx.globalAlpha = this.tweenObj.loading.alpha;  
      this.ctx.restore();
    },

    enter() { 
    },

    leave() {

      TweenLite.to(this.y, 0.5, {
        end: 0,
        onUpdate: () => {
          let bottom = this.r + this.padding + (this.BASE_HEIGHT - this.h);
          let y = (bottom + ((this.h - this.d - this.padding) * this.y.end)) * this.pixelRatio; 
          this.points.right.bottom.y = y;
          this.points.left.bottom.y = y;
          this.points.bottom.y = y;
          this.draw();
        },
        ease: 'Expo.easeInOut',
        onComplete: this.onLeaveComplete
      });

      this.pill.hide(); 
      this.arrow.hide();  
    },

    onLeaveComplete() { 
      this.$router.replace({ name: 'intro' })
      this.removeEvents()
    },



    // input states

    up() {
      
      this.arrow.up(); 
      this.pill.up(); 
      this.dots.up(); 
 
      this.tweenObj.progress = this.$store.state.swipeup.progress;
      TweenLite.to(this.tweenObj, 1, {
          progress: 0,
          onUpdate: () => {
              this.setProgress(this.tweenObj.progress);
          },
          ease: 'Quad.easeInOut'
      }) 
    },

    down(){
      TweenLite.killTweensOf(this.tweenObj);
      this.arrow.down(); 
      this.pill.down(); 
      this.dots.down(); 
 
    },

    continue(){
  
      if(!this.initialised && this.consented){
 
        this.setupViews(); 
        this.addEvents();
        this.pill.show(); 
        this.arrow.show(); 
        this.dots.show();

        this.initialised = true;
      } 
    }

  },

  watch: {  

    'input_state' (val){
      const STATES = this.$store.state.swipeup.INPUT_STATES;
      switch(val) {
        case STATES.UP:
          this.up();
          break;
        case STATES.DOWN:
          this.down();
          break;
        case STATES.COMPLETE:
          this.leave();
          break; 
      }
    },

    'consented'(val){
      this.continue()
    }
  }

   

}
</script>

<style lang="sass" >

  $diameter: 55px;
  $radius: $diameter / 2;
  $height: 180px;
  $bottom-margin: 100px;

  #swipe-cta
    width: $diameter; 
    position: absolute;
    top: calc(var(--viewport-height) - (80px  + 180px));
    left: 50%;
    margin-left: -$radius;

    .swipe-progress
      position: absolute;
      bottom: 0; 
    
 
</style> 